<div class="jumbo" [ngClass]="country" [style.background-image]="backgroundUrl">
  @if (country === 'de') {
    <div class="wrapper">
      <mat-tab-group mat-stretch-tabs="false" class="jumbo-mat-tab-group" [selectedIndex]="selectedIndex" dynamicHeight="true">
        @for (text of tabTexts; track text) {
          <mat-tab class="jumbo-text-container">
            <h2 class="jumbo-text" [innerHTML]="text"></h2>
          </mat-tab>
        }
      </mat-tab-group>
      <div class="switch">
        @for (text of tabTexts; track text; let i = $index) {
          <span
            (click)="change(i)"
            [class.active]="selectedIndex === i"
            >●</span
            >
          }
        </div>
      </div>
    }
  </div>
